export class LicenseAddEditConfig {
  public OrganizationID: number;
  public IsEdit: boolean;
  public OrgWLPSupportWebsite: string;
}
